import React, { useState } from 'react';
import { IntroTextBlock, ImageCard } from '../index';
import { VideoPlayer } from '_ui-core-js/React/components/VideoPlayer.jsx';

export function ExtraordinaryExperiences(props) {
    const { heading, copy, settings, onClickActions, links, video, items, disableFullscreenDefault, enableLbxLaunchUpdates } = props;
    const block = 'c-extraordinary-experiences';
    const [showVideoFullscreen, setShowVideoFullScreen] = useState(!disableFullscreenDefault);
    return (
        <>
            <article 
                className={`${block} dark-theme`}
            >
                <div className='container-xxl'>
                    <IntroTextBlock
                        block={block}
                        heading={heading}
                        copy={copy}
                        links={links}
                        onClickActions={onClickActions}
                    />
                    { !enableLbxLaunchUpdates &&
                        <VideoPlayer
                            src={video.url}
                            assetRootPath={`${settings.assetRootPath}/assets/images/`}
                            poster={video.poster}
                            fullscreen={showVideoFullscreen}
                            label={video.label}
                            onPlay={(isVideoPlayingFullscreen) => {
                                setShowVideoFullScreen(isVideoPlayingFullscreen)
                            }}
                            onEnd={() => {

                            }}
                            onPause={(isVideoPlayingFullscreen) => {
                                setShowVideoFullScreen(isVideoPlayingFullscreen);
                            }}
                        />
                    }
                    <div className={`${block}__cards`}>
                        { items.map((card, index) => 
                            <ImageCard
                                {...card}
                                block={block}
                            />
                        )}
                    </div>
                </div>
            </article>
        </>
    )
}